module.exports = __webpack_public_path__ + "files/b626436549c317f10ac9e303ed37ed06.png";